import type { FC } from "react";
import { clsx } from "clsx";
import LogoVector from "./logo.svg?react";

export type LogoProps = {
  className?: string;
  type?: "light" | "dark";
}

export const Logo: FC<LogoProps> = ({ className = "", type = "dark" }) => (
  <LogoVector className={clsx(className, type === "dark" ? "text-black" : "text-white")} />
);
